import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { Col, Row } from 'react-bootstrap';
import { PatternFormat } from 'react-number-format';
import { theme } from '_constants/theme';
import Button from '_components/atomic/Button';
import Icon from '_components/atomic/Icon';
import { ICONS_ALIASES } from '_constants/icons';
import { config } from '_config';
import DescriptionButton from '_components/atomic/DescriptionButton';
import { ROUTES } from '_constants/routes';
import RoundMenu from './RoundMenu';

const { colors, devices, fontSizes, spaces } = theme;

const StyledFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  padding-bottom: 50px;

  .footer-top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    max-width: ${spaces.large24X * 10 + 80}px;
    width: 100%;
    margin-bottom: 50px;

    .footer-top-logo {
      display: flex;
      align-items: center;
      width: 25%;
    }

    .footer-top-logo {
      justify-content: flex-start;
      width: 50%;
    }

    .footer-top-disclaimer {
      width: 50%;
      .childrenDescription {
        margin-left: 10px;
      }
    }
  }

  .footer-bottom {
    justify-content: space-between;
    align-items: center;
    max-width: ${spaces.large24X * 10 + 80}px;
    width: 100%;

    p {
      font-family: 'Aeonik';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 150%;
      color: ${({ theme }) => theme.colors.gray[600]};
    }
    .footer-bottom-menu {
      margin-bottom: 50px;
      h5 {
        font-family: 'Aeonik';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 130%;
        color: ${({ theme }) => theme.colors.gray[800]};
      }
      .phone a {
        font-family: 'Aeonik';
        font-style: normal;
        font-weight: 500;
        font-size: 36px;
        line-height: 150%;
        color: ${({ theme }) => theme.colors.blue[500]};
      }
      a {
        display: inline-block;
        width: 100%;
        font-family: 'Aeonik';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        color: ${({ theme }) => theme.colors.gray[600]};
        text-decoration: none;
        padding-top: 6px;
        padding-bottom: 6px;
        &:hover {
          text-decoration: underline;
        }
      }
      .text {
        display: block;
      }
      .contacts {
        .footer-bottom-line {
          display: none;
        }
      }
    }
  }
  .footer-bottom-line {
    height: 1px;
    background: ${({ theme }) => theme.colors.gray[200]};
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 8%;
    padding-right: 8%;
    margin-bottom: 30px;
    margin-top: 30px;
  }
  .footer-bottom-line-copyright {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: ${({ theme }) => theme.colors.gray[600]};
  }
  .footer-bottom-line-copyright-right {
    text-align: end;
  }
  .footer-bottom-line-row {
    display: flex;
  }
  @media ${devices.laptopM} {
    padding-left: ${spaces.large2X}px;
    padding-right: ${spaces.large2X}px;
  }
  @media ${({ theme }) => theme.devices.tablet} {
    padding-top: 30px;
    padding-bottom: 30px;
    padding-left: 16px;
    padding-right: 16px;
    .footer-legal {
      text-align: center;
      font-size: 14px !important;
    }
    .footer-top {
      flex-direction: column;
      justify-content: center;
      padding-left: 0;
      padding-right: 0px;
      margin-bottom: 16px;
      .footer-top-logo {
        justify-content: center;
        width: 100%;
        img {
          width: 80%;
          display: block;
          margin-left: auto;
          margin-right: auto;
        }
      }

      .footer-top-disclaimer {
        margin-top: 16px;
        width: 100%;
        .suffix {
          display: none;
        }
        .childrenDescription {
          margin-left: 0px;
        }
      }
    }

    .footer-bottom {
      flex-direction: column;
      justify-content: center;

      padding-left: 0;
      padding-right: 0;

      .footer-bottom-menu {
        margin-bottom: 0px;
        h5 {
          font-size: 14px;
        }
        a {
          font-size: 14px;
          padding-left: 0;
          padding-right: 0;
          width: 100%;
        }
        .otherServices {
          display: none;
        }
        .contacts {
          flex: 1 100%;
          text-align: center;
        }
        .contacts {
          .footer-bottom-line {
            display: flex;
          }
        }
        .text {
          display: inline;
        }
      }
      .footer-bottom-line-copyright {
        text-align: center;
      }
      .footer-bottom-line-copyright-right {
        text-align: center;
        margin-top: 24px;
      }
      .footer-bottom-line-row {
        display: block;
      }
      .footer-bottom-line {
        margin-bottom: 16px;
        margin-top: 16px;
      }
      p {
        margin-bottom: 0rem;
      }
    }
  }
`;

function Footer() {
  return (
    <StyledFooter>
      <div className="footer-top">
        <div className="footer-top-logo">
          <picture>
            <img
              src={`${config.basePath}/images/logo.svg`}
              alt=""
              layout="fill"
            />
          </picture>
        </div>
        <div className="footer-top-disclaimer"></div>
      </div>
      <div className="footer-bottom">
        <div className="footer-bottom-menu">
          <Row>
            <Col>
              <h5>QUICK LINKS</h5>
              <Link href={ROUTES.about}>About Us</Link>
              <Link href={ROUTES.contactUs}>Contact Us</Link>
              <Link href={ROUTES.guarantee}>Our Guarantee</Link>
              <Link href={ROUTES.terms}>Terms of Service</Link>
              <Link href={ROUTES.privacy}>Privacy Policy</Link>
            </Col>
            <Col>
              <h5>SERVICES</h5>
              <Link href={ROUTES.trademarkRegistration}>
                Trademark Registration
              </Link>
              <Link href={ROUTES.comprehensiveSearch}>
                Comprehensive Search
              </Link>
              <Link href={ROUTES.trademarkMonitoring}>
                Trademark Monitoring
              </Link>
              <Link href={ROUTES.search}>Free Trademark Search</Link>
              <Link href={ROUTES.trademarkRegistration}>
                Copyright Registration
              </Link>
              <Link href={ROUTES.officeActionResponse}>
                Office Action Response
              </Link>
              <Link href={ROUTES.logoDesignService}>Logo Design Service</Link>
            </Col>
            <Col className="otherServices">
              <h5>COMPANY</h5>
              <Link href={ROUTES.contactUs}>Contact Us</Link>
            </Col>
            <Col className="contacts">
              <div className="footer-bottom-line" />
              <h5>CUSTOMER SUPPORT</h5>
              <div className="phone">
                <a href={'tel:' + config.phone}>
                  <PatternFormat
                    value={config.phone?.substring(2)}
                    displayType="text"
                    format="(###) ###-####"
                  />
                </a>
              </div>
              <p>
                Reach us <span className="text">Monday - Friday 9am - 5pm</span>
              </p>
            </Col>
          </Row>
        </div>
        <Row>
          <Col>
            <div className="footer-bottom-line" />
          </Col>
        </Row>
        <Row className="footer-bottom-line-row">
          <Col className="footer-bottom-line-copyright">
            © Copyright {new Date().getFullYear()} Trademark Genius, LLC.
          </Col>
          <Col className="footer-bottom-line-copyright-right">
            <Icon
              alias={ICONS_ALIASES.facebook}
              color={theme.colors.gray[600]}
            />
            <span style={{ margin: '15px' }} />
            <Icon
              alias={ICONS_ALIASES.twitter}
              color={theme.colors.gray[600]}
            />
            <span style={{ margin: '15px' }} />
            <Icon
              alias={ICONS_ALIASES.linkedin}
              color={theme.colors.gray[600]}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="footer-bottom-line" />
          </Col>
        </Row>
        <p className="footer-legal">
          Trademark Genius provides information and software only. Trademark
          Genius is not a &quot;lawyer referral service&quot; and does not
          provide legal advice or participate in any legal representation. Use
          of Trademark Genius is subject to our Terms of Service and Privacy
          Policy.
        </p>
      </div>
      <RoundMenu />
    </StyledFooter>
  );
}

export default Footer;
